'use strict';

module.exports = function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/query/isWindow.js
 ** module id = 146
 ** module chunks = 0
 **/